import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Colors from '../../assets/styles/Colors'
import SuccessIcon from '../../assets/icons/JSX/SuccessIcon'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { AuthState } from '../../store/authSlice'
import { useTranslation } from 'react-i18next'
import api from '../../api'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader'
//
//
type new_user = {
  email: string
  password: string
}
//
//
const PaySuccessful = () => {
  //
  // login mutation
  const [login, { isLoading }] = api.useLoginMutation()
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const [new_user, setNew_user] = useState<new_user | null>(null)
  //
  //
  useEffect(() => {
    const newUserFromLocalStorage = localStorage.getItem('new_user')
    //
    const newUser = newUserFromLocalStorage && JSON.parse(newUserFromLocalStorage)
    //
    if (newUser) {
      setNew_user(newUser)
    }
    //
    return () => {}
  }, [new_user])
  //
  //
  const Login = async () => {
    if (new_user) {
      try {
        await login({ email: new_user.email, password: new_user.password }).unwrap()
        //
        localStorage.removeItem('new_user')
        navigate(`/my-policies`)
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage)
          localStorage.removeItem('new_user')
          navigate(`/login`)
        } else {
          toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (Login) (PaySuccessful)')
          localStorage.removeItem('new_user')
          navigate(`/login`)
        }
      }
    }
  }
  //
  //
  return isLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Icon />
      <Text>{t('paymentSuccessfully')}</Text>

      {auth.user && auth.user.userType === 'User' ? (
        <LinkStyle to="/my-policies">{t('goToProfile')}</LinkStyle>
      ) : new_user ? (
        <NewUserDiv onClick={Login}>{t('goToProfile')}</NewUserDiv>
      ) : (
        <LinkStyle to="/login">{t('signIn')}</LinkStyle>
      )}
    </Wrapper>
  )
}
//
// styles
const NewUserDiv = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-top: 15px;
  cursor: pointer;
  text-decoration: underline;
  user-select: none;
  &:hover {
    color: ${Colors.primaryBlack};
    opacity: 0.9;
  }
`
const LinkStyle = styled(Link)`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-top: 15px;
  &:hover {
    color: ${Colors.primaryBlack};
    opacity: 0.9;
  }
`
const Text = styled.div`
  text-align: center;
  font-size: 24px;
  color: ${Colors.primaryBlack};
  margin-top: 10px;
`
const Icon = styled(SuccessIcon)`
  background-color: transparent;
  width: 200px;
  height: 180px;
`
const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  background-color: ${Colors.backgroundGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export default PaySuccessful
